<template>
  <div>
    <BaseTableList
        :table-set-list="cooperatelist"
        :display-items="cooperates"
        class="cooperates-table" />
  </div>
</template>

<style scoped>
</style>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapGetters } from 'vuex'

import * as define from '@/define'
import BaseTableList from '@/components/molecules/BaseTableList'
import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'

export default {
  name: 'OrderDetailCooperates',
  components: {
    BaseTableList
  },
  props: {
    orderCooperates: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    define: () => define,
    ...mapGetters({
      apiErrorReason: 'apiErrorReason'
    }),
    cooperates () {
      return _.chain(this.orderCooperates)
        .sortBy([val => moment(val.createdAt)])
        .reverse()
        .value()
    },
    cooperatelist () {
      return [
        { label: 'API名', path: 'apiName', type: 'String', codeName: 's_api_cooperate.api_name',
          funcId: define.PermissionKeys.Order.Detail.Cooperate.API_NAME },
        { label: 'リクエスト日時', path: 'requestedAt', type: 'Date',
          funcId: define.PermissionKeys.Order.Detail.Cooperate.REQUESTED_AT },
        { label: 'レスポンス日時', path: 'responsedAt', type: 'Date',
          funcId: define.PermissionKeys.Order.Detail.Cooperate.RESPONSED_AT },
        { label: 'エラー理由', path: this.errorReason, type: 'String',
          funcId: define.PermissionKeys.Order.Detail.Cooperate.ERROR_REASON,
          elementType: ELEMENT_TYPE.FUNCTION },
        { label: '登録日時', path: 'createdAt', type: 'Date',
          funcId: define.PermissionKeys.Order.Detail.Cooperate.CREATED_AT }
      ]
    }
  },
  watch: {
  },
  methods: {
    errorReason (row) {

      // エラー理由コードからエラー理由を設定する
      let errorMessage = this.apiErrorReason(null, row.apiName, row.errorReasonCode)

      if (errorMessage === '') {
        return row.errorReasonCode
      }
      return errorMessage
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/order/OrderDetailCooperates.vue